const alias = {
  id: 'id',
  name: 'name'
};
const requestAlias = {
  pageSize: 'pageSize',
  pageIndex: 'pageIndex',
  queryValue: 'queryValue',
  entity: 'entity'
}
export default {
  props: {
    value: {
      type: [Object, Array, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    displayFields: {
      type: Array,
      required: false
    },
    alias: {
      type: Object,
      default () {
        return alias;
      }
    },
    requestAlias: {
      type: Object,
      default () {
        return requestAlias;
      }
    },
    title: String,
    fetch: {
      type: Function,
      default: null
    },
    max: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    // 自定义清空按钮图标
    clearIconName: {
      type: String,
      default: undefined
    },
    // 自定义清空按钮位置
    clearIconRight: {
      type: Number,
      default: 0
    },
    /**
     * @public 是否需要保持选中项在翻页的时候
     */
    keepSelected: {
      type: Boolean,
      default: true
    },
    /**
     * @public 配置弹窗宽度
     */
    size: {
      type: String,
      default: 'large'
    },
    /**
     * @public 返回输入建议的方法
     */
    fetchSuggestions: {
      type: Function,
      default: null
    },
    /**
     * @public 允许输入
     */
    allowInput: {
      type: Boolean,
      default: true
    },
    /**
     * @public 可以创建选项中不存在的条目
     */
    allowCustomValue: {
      type: Boolean,
      default: false
    },
    /**
     * @public 后缀图标
     */
    suffixIconName: {
      type: String,
      default: 'rt-base-lookup'
    },
    /**
     * @public 请求参数的字段名
     */
    pageFields: {
      type: Object,
      default () {
        return {};
      }
    },
    popoverOptions: {
      type: Object,
      default () {
        return {
          trigger: 'hover'
        };
      }
    },
    /**
     * 后缀图标 tooltip 内容
     */
    iconContent: {
      type: String,
      default: ''
    },
    emptyPlaceholder: {
      type: String,
      default: ''
    },
    triggerOnFocus: {
      type: Boolean,
      default: false
    },
    // 选项中是否启用描述
    hideOptionDesc: {
      type: Boolean,
      default: false
    }
  },
  data () {
    let list = [];
    if (this.$xpc.isArray(this.value)) {
      list = this.value;
    } else if (this.$xpc.isObject(this.value)) {
      list = [this.value];
    }
    return {
      visible: false,
      inputText: this.$xpc.isString(this.value) ? this.value : null,
      total: 0,
      list: list,
      contentPopover: '',
      inputHovering: false,
      inputWidth: 0,
      maxIndex: 0,
      isLink: false,
      defaultPopoverOptions: {
        trigger: 'hover'
      },
      tagInputFocus: false,
      tagInputText: '',
      lookupHeight: 0,
      forceLoadData: false // 是否强制加载 loadData
    };
  },
  provide () {
    return {
      rtLookup: this
    }
  },
  inject: {
    elForm: {
      default: ''
    }
  },
  computed: {
    computedPopoverOptions () {
      return { ...this.defaultPopoverOptions, ...this.popoverOptions };
    },
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    },
    computedRequestAlias () {
      return { ...requestAlias, ...this.requestAlias }
    },
    innerPageFields () {
      return {
        pageSize: this.computedRequestAlias['pageSize'],
        pageIndex: this.computedRequestAlias['pageIndex'],
        queryValue: this.computedRequestAlias['queryValue'],
        entity: this.computedRequestAlias['entity'],
        ...this.pageFields
      };
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        if (this.$xpc.isArray(newVal)) {
          newVal = newVal.filter((item) => {
            return item[this.alias.id];
          });
          this.list = newVal;
        } else if (this.$xpc.isObject(newVal) && newVal[this.alias.id]) {
          this.list = [newVal];
        } else if (this.$xpc.isString(newVal)) {
          this.toEmptyList();
          this.inputText = newVal;
        } else {
          this.list = [];
        }
      }
    },
    // 当选择标签数量调整时，监听选中标签数量变化，展示收起标签个数
    list (val) {
      if (this.max) {
        this.$nextTick(() => {
          const tagList = this.$refs.tag
            ? Array.from(this.$refs.tag.getElementsByClassName('rt-tag-box'))
            : [];
          let width = 0;
          let _maxIndex = 0;
          for (let i = 0; i < tagList.length; i++) {
            width += tagList[i].offsetWidth;
            const lookupIconWidth = 32; // lookup图标宽度
            const clearIconWidth = 32; // 清除图标宽度
            const maxNumTagWidth = 56; // 此处为预估数字标签宽度，暂估最大值为两位数
            // 当原标签列表宽度大于输入框宽度减去（lookup图标宽度 + 清除图标宽度 + 预估数字标签宽度）
            if (
              width + 8 * i >=
              this.inputWidth - (lookupIconWidth + clearIconWidth + maxNumTagWidth)
            ) {
              break;
            }
            _maxIndex = i;
          }
          this.maxIndex = _maxIndex + 1;
          this.showPopover();
        });
      }
      if (!this.$xpc.isString(this.value)) {
        this.inputText = '';
        this.tagInputText = '';
      }
    },
    // 当屏幕大小调整时，监听输入框宽度变化，展示收起标签个数
    inputWidth (val) {
      if (this.max) {
        this.$nextTick(() => {
          const tagList = this.$refs.tag
            ? Array.from(this.$refs.tag.getElementsByClassName('rt-tag-box'))
            : [];
          let width = 0;
          let _maxIndex = 0;
          for (let i = 0; i < tagList.length; i++) {
            width += tagList[i].offsetWidth;
            const lookupIconWidth = 32;
            const clearIconWidth = 32;
            const maxNumTagWidth = 56;
            if (
              width + 8 * i >=
              val - (lookupIconWidth + clearIconWidth + maxNumTagWidth)
            ) {
              break;
            }
            _maxIndex = i;
          }
          this.maxIndex = _maxIndex + 1;
          this.showPopover();
        });
      }
    }
  },
  methods: {
    mouseenter () {
      setTimeout(() => {
        this.inputHovering = true;
      });
    },
    mouseleave () {
      setTimeout(() => {
        this.inputHovering = false;
      });
    },
    shouldLoadDataIfShow () {
      this.forceLoadData = true;
    },
    show () {
      if (this.computedDisabled) {
        return;
      }
      if (this.$refs && this.$refs.lookupView) {
        this.$refs.lookupView.visible = true;
        if (this.forceLoadData) {
          this.$nextTick(() => {
            this.$refs.lookupView.$refs.table.handleIndexChange(1);
            this.$refs.lookupView.loadData();
            this.forceLoadData = false;
          });
        }
      }
    },
    /** 移植element-ui/src/mixins/emitter 中的方法 */
    dispatch (componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    fetchRecord (params) {
      if (this.fetch) {
        return this.fetch(params).then(res => {
          this.total = res.total;
          return res.data;
        });
      } else {
        return this.$lookup.getLookupData(params).then(res => {
          this.total = res.total;
          return res.data;
        });
      }
    },
    // 处理设置最多显示项时，剩余数量的popover的内容
    // 处理逻辑是slice(max值)数据list，循环拼接每一项的内容给到最后赋值给popover content的变量
    // 因UI设计最后一条无分号，拼接后做了substring去掉最后一个 ‘分号’ 字符
    showPopover () {
      let str = '';
      this.list.slice(this.maxIndex).forEach(item => {
        str += item[this.alias.name] + ';';
      });
      str = str.substring(0, str.length - 1);
      this.contentPopover = str;
    },
    // 是否执行show方法
    rtLookupShowHandler () {
      !this.allowInput && this.show();
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/lookup/mixin.js